<template>
  <section class="subjectAndTextbookPage">
    <g-breadcrumb bread="教材管理, 科目与教材管理" />
    <SearchForm v-if="activeTabsName === 'textBook'">
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
        <el-form-item label="" prop="keyWord">
          <el-input v-model="searchForm.teachingName" :placeholder="activeTabsName === 'textBook'?'请输入教材名称':'请输入科目名称'" />
        </el-form-item>
        <el-form-item label="" prop="orgLevek=l">
          <GSelect v-model="searchForm.teachingGrade" :options="selectOptionsLevel" :placeholder="'请选择教材等级'" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBySync">搜 索</el-button>
          <!-- <el-button type="success" icon="el-icon-search" @click="fetchData">搜 索</el-button> -->
        </el-form-item>
      </el-form>
    </SearchForm>
    <SearchForm v-if="activeTabsName === 'subject'">
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
        <el-form-item label="" prop="keyWord">
          <el-input v-model="searchTextbookForm.subjectName" :placeholder="activeTabsName === 'textBook'?'请输入教材名称':'请输入科目名称'" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBySync">搜 索</el-button>
          <!-- <el-button type="success" icon="el-icon-search" @click="fetchData">搜 索</el-button> -->
        </el-form-item>
      </el-form>
    </SearchForm>
    <TableContainer title="">
      <template slot="button">
        <el-button v-show="activeTabsName === 'textBook'" type="warning" class="add-button" @click="addEventCenter('textBook')">添加教材</el-button>
        <el-button v-show="activeTabsName === 'subject'" type="warning" class="add-button" @click="addEventCenter('subject')">添加科目</el-button>
      </template>
      <el-tabs v-model="activeTabsName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="教材" name="textBook">
          <div class="tableContainer">
            <el-table :data="textBookTableData" max-height="auto">
              <el-table-column prop="subjectName" label="所属科目" min-width="100" />
              <el-table-column prop="teachingType" label="教材类型" min-width="120">
                <template slot-scope="scope">
                  <div v-show="scope.row.teachingType === 'SYSTEMTEACHING'">系统教材</div>
                </template>
              </el-table-column>
              <el-table-column prop="teachingName" label="教材名称" min-width="120" />
              <el-table-column prop="teachingEnName" label="教材英文名称" min-width="100" />
              <el-table-column prop="teachingGrade" label="教材等级" min-width="100" />
              <el-table-column prop="gradeName" label="推荐年级" min-width="100" />
              <el-table-column prop="teachingPrice" label="线上价格" min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.teachingPrice">{{ scope.row.teachingPrice }}</div>
                  <div v-else>/</div>
                </template>
              </el-table-column>
              <el-table-column prop="bookPrice" label="实体书价格" min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.bookPrice">{{ scope.row.bookPrice }}</div>
                  <div v-else>/</div>
                </template>
              </el-table-column>
              <el-table-column prop="setmealPrice" label="套餐价格" min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.setmealPrice">{{ scope.row.setmealPrice }}</div>
                  <div v-else>/</div>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.remark"> {{ scope.row.remark }}</div>
                  <div v-else> - -</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" class="textPurple" @click="editTextBook(scope.row)">编辑</el-button>
                  <el-button type="text" class="textOrange" @click="deleteCenter(scope.row,'textBook')">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <GPagination
              v-show="searchForm.total > 0"
              ref="ref_GPagination"
              :total.sync="searchForm.total"
              :page.sync="searchForm.page"
              :current-page="searchForm.page"
              :size.sync="searchForm.size"
              @pagination="fetchData"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="科目" name="subject">
          <div class="tableContainer">
            <el-table :data="subjectTableData" border>
              <el-table-column prop="subject" label="科目名称" min-width="100" />
              <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.remark"> {{ scope.row.remark }}</div>
                  <div v-else> - -</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="100">
                <template slot-scope="scope">
                  <el-button type="text" class="textPurple" @click="editSubject(scope.row)">编辑</el-button>
                  <el-button type="text" class="textOrange" @click="deleteCenter(scope.row,'subjectBook')">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <GPagination
              v-show="searchTextbookForm.total > 0"
              ref="ref_GPagination"
              :total.sync="searchTextbookForm.total"
              :page.sync="searchTextbookForm.page"
              :current-page="searchTextbookForm.page"
              :size.sync="searchTextbookForm.size"
              @pagination="fetchData"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </TableContainer>
    <!-- 添加科目dialog-->
    <GDialog
      :dialog.sync="subjectDialog"
      :width="'60%'"
      @btnSure="submitForm('subjectRef')"
      @btnClose="resetsubjectForm('subjectRef')"
    >
      <subject-page ref="subjectRef" :subject-form.sync="subjectForm" />
    </GDialog>
    <!--    <GDialog-->
    <!--      :dialog.sync="addSubjectDialog"-->
    <!--      :width="'60%'"-->
    <!--      @btnSure="submitForm('add_subjectRef')"-->
    <!--      @btnClose="resetsubjectForm('add_subjectRef')"-->
    <!--    >-->
    <!--      <subject-page ref="add_subjectRef" :subject-form.sync="addSubjectForm" />-->
    <!--    </GDialog>-->
    <!--    <GDialog-->
    <!--      :dialog.sync="subjectDialog"-->
    <!--      :width="'60%'"-->
    <!--      @btnSure="submitForm('edit_subjectRef')"-->
    <!--      @btnClose="resetsubjectForm('edit_subjectRef')"-->
    <!--    >-->
    <!--      <subject-page ref="edit_subjectRef" :subject-form.sync="editSubjectForm" />-->
    <!--    </GDialog>-->
    <!--编辑科目dialog-->
    <GDialog :dialog.sync="textBookDialog" @btnSure="submitFormTextBook('textRef')" @btnClose="resetTextBookForm('textRef')">
      <editPage ref="textRef" :text-book-form.sync="textBookForm" :timestamp="timestamp" />
    </GDialog>

  </section>
</template>

<script>
import { getTextBookBySearch, getSelectSubjectList, addTeachingBook,
  deleteTeachingBook, updateTeachingBook, addSubjectBook, deleteSubjectBook, updateSubjectBook } from '@api/teachBookManagement/subjectAndTextbook'
import editPage from './editPage.vue'
import { mapActions, mapState } from 'vuex'
import { textBookToTabelFunction, currentPage } from '../../../utils/reg'
import SubjectPage from './subjectPage.vue'
export default {
  components: {
    editPage,
    SubjectPage
  },
  data() {
    return {
      activeTabsName: 'textBook',
      currentSubjectRow: {},
      currentTextBookRow: {},
      subjectDialog: {
        title: '标题',
        visible: false
      },
      textBookDialog: {
        title: '标题',
        visible: false
      },
      subjectTableData: [],
      textBookTableData: [],
      // total: 0,
      searchForm: { teachingName: '', page: 1, size: 20, total: 0, teachingGrade: '' },
      searchTextbookForm: { subjectName: '', page: 1, size: 20, total: 0 },
      subjectForm: { subjectName: '', remark: '', page: 1, size: 20, total: 0 },
      textBookForm: {
        gradeType: '',
        subjectId: '',
        teachingType: '',
        teachingName: '',
        teachingEnName: '',
        teachingGrade: '',
        teachingPrice: '',
        bookPrice: '',
        setmealPrice: '',
        teachingPath: '',
        gradeCode:'',
        minBabyAge:'',
        minBabyMonth:'',
        maxBabyAge:'',
        maxBabyMonth:'',
        filePath: '',
        fileList: [{
          name: '',
          id: '',
          url: ''
        }],
        filePathList: [{
          name: '',
          id: '',
          url: ''
        }],
        textBookForm: {

        }
      },
      timestamp: 0,
      isSearchText: false,
      isSearchSubject: false
    }
  },
  computed: {
    ...mapState('commonModule', ['orgAreaTree']),
    ...mapState('commonModule', ['selectOptionsLevel', 'selectOptionsSubject']),
    ...mapState('gardenManagement', ['textBookRules'])
  },
  created () {
    this.getOptions()
    this.fetchData()
    this.GET_SUBJECTTREE()
    this.GET_LEVELSELECTTREE()
  },
  methods: {
    ...mapActions('commonModule', ['GET_SUBJECTTREE', 'GET_LEVELSELECTTREE']),
    restData() {
      return {
        gradeType: '',
        subjectId: '',
        teachingType: '',
        teachingName: '',
        teachingEnName: '',
        teachingGrade: '',
        teachingPrice: '',
        bookPrice: '',
        setmealPrice: '',
        level: '',
        teachingPath: '',
        fileList: [{
          name: '',
          id: '',
          url: ''
        }]
      }
    },
    getOptions () {
      // 查询组织机构树-到片区；2到片区，3到园所
      this.$store.dispatch('commonModule/getOrgTree', 2)
    },
    dataFilter(obj, isEdit) {
      const res = {
        bookPrice: obj.bookPrice,
        gradeType: obj.gradeType,
        remark: obj.remark,
        setmealPrice: obj.setmealPrice,
        subjectId: obj.subjectId,
        teachingEnName: obj.teachingEnName,
        teachingGrade: obj.teachingGrade,
        teachingName: obj.teachingName,
        teachingPath: obj.fileList[0].url,
        teachingPrice: obj.teachingPrice,
        teachingType: obj.teachingType,
        gradeCode: obj.gradeCode,
        minBabyAge: obj.minBabyAge,
        minBabyMonth: obj.minBabyMonth,
        maxBabyAge: obj.maxBabyAge,
        maxBabyMonth: obj.maxBabyMonth,
        filePath: obj.filePathList[0].url
      }
      if (isEdit === 'true') {
        res.id = obj.id
      }
      return res
    },
    // 异步搜索
    async fetchData() {
      try {
        if (this.activeTabsName === 'textBook') {
          const RES = await getTextBookBySearch(this.searchForm)
          // 为了方便页面内进行传值，在接受数据的时候就进行一次处理
          RES.records.forEach(element => {
            element.fileList = [{
              url: element.teachingPath,
              id: 0,
              name: ''
            }]
            element.filePathList = [{
              url: element.filePath,
              id: 0,
              name: ''
            }]
          })
          this.textBookTableData = RES.records
          this.searchForm.total = RES.total
          // this.searchForm.size = RES.size
        }
        if (this.activeTabsName === 'subject') {
          const RES = await getSelectSubjectList(this.searchTextbookForm)
          this.subjectTableData = RES.records
          this.searchTextbookForm.total = RES.total
          // this.searchTextbookForm.size = RES.size
        }
      } catch (error) {
        this.$message.error('获取失败')
      }
    },
    // 判断是否是在搜索后切换tab板的逻辑，如果在搜索后切换tab，就清空搜索条件
    handleTabClick(e) {
      if (e.index === '0') {
        if (this.isSearchSubject) {
          this.searchTextbookForm.subjectName = ''
          this.isSearchSubject = false
          this.fetchData()
        } else {
          this.isSearchSubject = false
          this.fetchData()
        }
      } else if (e.index === '1') {
        if (this.isSearchText) {
          this.searchForm.teachingName = ''
          this.searchForm.teachingGrade = ''
          this.isSearchText = false
          this.fetchData()
        } else {
          this.isSearchText = false
          this.fetchData()
        }
      }
    },
    // 异步搜索，并在每次重新搜索时重置页码为1
    searchBySync() {
      if (this.activeTabsName === 'textBook') { // 获取教材接口
        this.searchForm.page = 1
        this.fetchData()
        this.isSearchText = true
      } else if (this.activeTabsName === 'subject') { // 获取科目接口
        this.searchTextbookForm.page = 1
        this.fetchData()
        this.isSearchSubject = true
      }
    },
    addEventCenter(addEventName) {
      this.GET_SUBJECTTREE()
      if (addEventName === 'textBook') {
        this.textBookDialog.visible = true
        this.textBookDialog.title = '添加'
      }
      if (addEventName === 'subject') {
        this.subjectDialog.visible = true
        this.subjectDialog.title = '添加'
      }
    },
    // 编辑科目的打开事件
    editSubject (row) {
      this.subjectDialog.visible = true
      this.subjectDialog.title = '编辑'
      this.currentSubjectRow = row
      this.$nextTick(() => {
        this.subjectForm = { ...row }
        this.timestamp = Date.now()
      })
    },
    // 编辑教材的打开事件
    editTextBook (row) {
      this.textBookForm = textBookToTabelFunction({ ...row })
      this.GET_SUBJECTTREE()
      this.textBookDialog.visible = true
      this.textBookDialog.title = '编辑'
      this.currentTextBookRow = row
      this.$nextTick(() => {
        this.timestamp = Date.now()
      })
    },
    // 重置科目表单
    resetsubjectForm(formName) {
      this.$refs[formName].$refs.ref_subjectForm.resetFields()
      if (formName === 'add_subjectRef') {
        this.subjectDialog.visible = false
        this.subjectForm = {}
      } else {
        this.subjectDialog.visible = false
        this.subjectForm = {}
      }
    },
    // 重置教材表单
    resetTextBookForm(formName) {
      this.$refs[formName].$refs.ref_textBookForm.resetFields()
      if (this.textBookDialog.title === '添加') {
        this.textBookDialog.visible = false
        this.textBookForm = this.restData()
      } else {
        this.textBookDialog.visible = false
        this.textBookForm = this.restData()
      }
    },
    // 事件删除判断中心
    deleteCenter(row, arrayName) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning'
      }).then(() => {
        this.currentRow = row
        switch (arrayName) {
          case 'textBook':
            this.deleteRequest(deleteTeachingBook, { materialId: row.id }, arrayName)
            break
          case 'subjectBook':
            this.deleteRequest(deleteSubjectBook, { id: row.id }, arrayName)
            break
        }
      })
    },
    // 删除事件请求
    async deleteRequest(api, row, name) {
      try {
        await api(row)
        this.$message.success('删除成功')
        name === 'textBook' ? this.searchForm.page = currentPage(this.searchForm.page, this.searchForm.size, this.searchForm.total) : this.searchTextbookForm.page = currentPage(this.searchTextbookForm.page, this.searchTextbookForm.size, this.searchTextbookForm.total)
        this.fetchData()
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    },
    // 提交科目还是编辑科目
    submitForm(formName) {
      const ref = this.$refs[formName].$refs.ref_subjectForm
      ref.validate(valid => {
        if (!valid) { return false }
        let PARAMS
        let _api
        if (this.subjectDialog.title === '添加') {
          PARAMS = { ...this.subjectForm }
          _api = addSubjectBook
        } else {
          PARAMS = { ...this.subjectForm }
          _api = updateSubjectBook
          PARAMS.orgId = this.currentSubjectRow.id
        }
        // 使用函数进行统一的请求判断
        this.submitRequest(_api, PARAMS, 'subjectRef')
      })
    },
    // 提交教材的条件判断,并在判断后进行一次数据转换
    submitFormTextBook(formName) {
      const ref = this.$refs[formName].$refs.ref_textBookForm
      ref.validate(valid => {
        if (!valid) { return false }
        // if (!this.textBookForm.teachingPrice && !this.textBookForm.bookPrice && !this.textBookForm.setmealPrice) {
        //   this.$message.closeAll()
        //   this.$message.error('请填写至少一项价格')
        //   return false
        // }
        let PARAMS
        let _api
        if (this.textBookDialog.title === '添加') {
          if (this.textBookForm.fileList[0].url.length < 1) {
            this.$message.error('请上传封面图')
            return
          }
          PARAMS = this.dataFilter(this.textBookForm, 'false')
          _api = addTeachingBook
          // this.textSubmitRequest(_api, PARAMS, 'textRef')
        } else {
          if (!this.textBookForm.fileList[0].url) {
            this.$message.error('请上传封面图')
            return
          }
          PARAMS = this.dataFilter(this.textBookForm, 'true')
          _api = updateTeachingBook
          PARAMS.orgId = this.currentTextBookRow.id
        }
        // 统一进行请求
        this.textSubmitRequest(_api, PARAMS, 'textRef')
      })
    },
    // 科目的统一请求判断
    async submitRequest(api, params, refName) {
      try {
        await api(params)
        this.$message.success('操作成功')
        this.resetsubjectForm(refName)
        this.fetchData()
      } catch (error) {
        this.$message.closeAll()
        this.$message.error(error)
      }
    },
    // 教材的统一请求判断
    async textSubmitRequest(api, params, refName) {
      try {
        await api(params)
        this.$message.success('操作成功')
        this.resetTextBookForm(refName)
        this.fetchData()
      } catch (error) {
        this.$message.closeAll()
        this.$message.error(error)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.subjectAndTextbookPage{
  .el-tabs__header{
    margin-bottom: 0;
  }
}
.add-button{
  position:absolute;
  right: 30px;
  top: 20px;
  z-index: 999;
}
.table-container{
  position: relative;
}
/deep/.el-tabs__content{
  max-height: none!important;
}
/deep/.el-tabs__header{
  margin:0px!important
}
</style>
